import { removeCharacters } from './functions';

export const sanitizePhoneNumber = (phoneNumber: string) => {
    return removeCharacters([' ', '-', '+46', '+45', '+47'], phoneNumber || '') as string;
};

export const isPhoneNumberValid = (
    code: PhoneCountryCode | string | undefined,
    phoneNumber: string
) => {
    switch (code) {
        case PhoneCountryCode.Finland: // Finland
            return Boolean(phoneNumber.match(/^\d{4,14}$/));
        case PhoneCountryCode.Denmark: // Denmark
            return Boolean(phoneNumber.match(/^\d{8}$/));
        case PhoneCountryCode.Sweden: // Sweden
            return Boolean(phoneNumber.match(/^\d{7,13}$/));
        case PhoneCountryCode.Norway: // Norway
            return Boolean(phoneNumber.match(/^\d{8}$/));
    }

    return false;
};

export enum PhoneCountryCode {
    Denmark = '+45',
    Sweden = '+46',
    Norway = '+47',
    Finland = '+358',
}
